<template>
  <v-dialog v-model="dialog" max-width="500px">
    <template #activator="{on}">
      <v-btn depressed color="#D9E7FC" class="btn-medium mr-2" v-on="on">
        Import CBS Post Date
      </v-btn>
    </template>

    <ValidationObserver ref="form" v-slot="{ handleSubmit, invalid }">
      <form
        novalidate
        autocomplete="off"
        @submit.prevent="handleSubmit(onSubmit)"
      >
        <v-card>
          <v-card-title
            class="primary white--text fs-16 lh-20 font-weight-bold py-4 px-6"
          >
            <span class="pa-0">
              Import CBS Post Date
            </span>
            <v-spacer></v-spacer>
            <v-btn color="white" fab x-small depressed>
              <v-icon
                @click="dialog = false"
                color="primary"
                class="fs-18 font-weight-bold"
              >
                close
              </v-icon>
            </v-btn>
          </v-card-title>

          <v-card-text class="py-2">
            <ValidationProvider
              slim
              name="File"
              rules="required"
              v-slot="{ errors }"
              :vid="`fileInput`"
            >
              <v-file-input
                :id="`fileInput`"
                v-model="file"
                class="mt-4"
                prepend-icon=""
                append-icon="mdi-attachment"
                placeholder="File"
                label="File"
                :error-messages="errors"
                outlined
                dense
              />
            </ValidationProvider>
          </v-card-text>
          <v-card-actions class="px-4 pt-0">
            <v-row dense>
              <v-col cols="12">
                <v-btn
                  type="submit"
                  class="btn-medium"
                  color="#D9E7FC"
                  depressed
                  block
                  :disabled="loading"
                  @click="downloadTemplate"
                >
                  Download Template
                </v-btn>
              </v-col>
              <v-col cols="12">
                <v-btn
                  type="submit"
                  class="btn-medium white--text"
                  color="menuActive"
                  depressed
                  :loading="loading"
                  block
                >
                  Submit
                </v-btn>
              </v-col>
            </v-row>
          </v-card-actions>
        </v-card>
      </form>
    </ValidationObserver>
  </v-dialog>
</template>

<script>
import { getAccessToken } from '@/api';
import Swal from 'sweetalert2';

export default {
  data: () => ({
    dialog: false,
    file: null,
    loading: false
  }),
  methods: {
    async onSubmit() {
      this.loading = true;
      const res = await this.$store.dispatch('sshcf/importCBS', this.file);
      this.loading = false;
      if (res.code === 200) {
        this.file = null;
        this.$refs.form.reset();
        Swal.fire('Success!', res.message.text_en, 'success');
      } else {
        Swal.fire('Failed!', res.message.text_en, 'error');
      }
    },
    downloadTemplate() {
      const token = getAccessToken();
      const url =
        process.env.VUE_APP_BASE_URL + '/v1/sshcf/cbs/template?token=' + token;
      window.open(url, '_blank');
    }
  }
};
</script>

<style scoped></style>
